import { WorkflowPhase } from './api/types';

export const PHASE_COLOR: Record<WorkflowPhase, string> = {
  Pending: '#9e9e9e',
  Running: '#fdd835',
  Succeeded: '#388e3c',
  Failed: '#d32f2f',
  Error: '#d32f2f',
  Unknown: '#9e9e9e',
};
